exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-bar {\n\tmargin: 10px auto;\n}\n\n#loading {\n\theight: 16px;\n\twidth: auto;\n\tmargin: 0 auto;\n\tborder-radius: 50%;\n}\n\n@media (max-width: 768px) {\n\t.button-bar .btn {\n\t\twidth: 90%;\n\t\tmargin: auto;\n\t\tmargin-left: 5%;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.signs {\n\t\tmargin-left: 10%;\n\t}\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/display/display-section/display-section.component.css
// module id = ../../../../../src/app/display/display-section/display-section.component.css
// module chunks = main